var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 58.1361C0.399902 73.4126 6.46846 88.0634 17.2706 98.8655C28.0726 109.668 42.7234 115.736 57.9999 115.736C73.2764 115.736 87.9272 109.668 98.7293 98.8655C109.531 88.0634 115.6 73.4126 115.6 58.1361C115.6 42.8597 109.531 28.2089 98.7293 17.4068C87.9272 6.60469 73.2764 0.536133 57.9999 0.536133C42.7234 0.536133 28.0726 6.60469 17.2706 17.4068C6.46846 28.2089 0.399902 42.8597 0.399902 58.1361Z",
    fill: "#F8F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M73.6295 107.585C73.6295 106.463 66.9594 105.553 58.7312 105.553C50.5031 105.553 43.833 106.463 43.833 107.585C43.833 108.706 50.5031 109.616 58.7312 109.616C66.9594 109.616 73.6295 108.712 73.6295 107.585Z",
    fill: "#1E0A3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8799 89.3365C24.8794 89.68 24.9907 90.0145 25.197 90.2893C25.4032 90.5641 25.6932 90.7644 26.0232 90.86L57.0596 99.9133C57.369 100.004 57.6905 100.046 58.0128 100.039V62.9168L24.8799 53.2529V89.3365Z",
    fill: "#F7E5C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7682 75.2533L58.0128 68.0086V62.9153L24.8799 53.2529V67.7033L50.7682 75.2533Z",
    fill: "#F0D5A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0128 62.9165L24.8799 53.2527L58.0128 43.5889L91.1444 53.3751L58.0128 62.9165Z",
    fill: "#DEBB7E",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0128 62.9165L24.8799 53.2527L58.0128 43.5889V62.9165Z",
    fill: "#B89558",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0127 62.9174V100.039C58.3325 100.033 58.6495 99.9786 58.953 99.8779L90.057 89.5099C90.3742 89.4051 90.6502 89.2028 90.8454 88.9317C91.0407 88.6607 91.1453 88.3348 91.1442 88.0008V53.376L58.0127 62.9174Z",
    fill: "#F0D5A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1565 75.2539L91.1442 67.6449L91.1457 53.376L58.0127 62.916V67.0646L65.1565 75.2539Z",
    fill: "#DEBB7E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0128 62.9168L24.8799 53.2529V89.3365C24.8794 89.68 24.9907 90.0145 25.197 90.2893C25.4032 90.5641 25.6932 90.7644 26.0232 90.86L57.0596 99.9118C57.6796 100.093 58.3401 100.081 58.9532 99.8773L90.0572 89.5092C90.3744 89.4045 90.6503 89.2021 90.8456 88.9311C91.0408 88.66 91.1454 88.3342 91.1444 88.0001V53.3753L58.0128 62.9168Z",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2782 44.2701C19.0072 44.34 18.7596 44.4805 18.5606 44.6772C18.3615 44.8738 18.2181 45.1197 18.1449 45.3898C18.0718 45.6599 18.0715 45.9446 18.1441 46.2148C18.2167 46.4851 18.3595 46.7313 18.5582 46.9284L24.8798 53.2529L58.0127 43.589L49.5571 37.5497C49.1788 37.279 48.7456 37.0949 48.2881 37.0106C47.8307 36.9262 47.3603 36.9436 46.9104 37.0615L19.2782 44.2701Z",
    fill: "#DEBB7E",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0592 69.8705C50.6562 70.2737 50.152 70.561 49.5996 70.7021C49.0473 70.8433 48.4671 70.8331 47.92 70.6726L19.1704 62.2861C18.905 62.2098 18.6642 62.0654 18.4718 61.8674C18.2793 61.6693 18.1421 61.4244 18.0735 61.1569C18.005 60.8894 18.0075 60.6086 18.081 60.3424C18.1544 60.0762 18.2962 59.8338 18.4922 59.6393L24.88 53.2529L58.013 62.9168L51.0592 69.8705Z",
    fill: "#F0D5A8",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0127 62.917V100.039",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2822 44.2889C96.5956 44.371 96.8818 44.5343 97.1118 44.7624C97.3418 44.9904 97.5076 45.2752 97.5923 45.5878C97.6771 45.9005 97.6778 46.23 97.5944 46.543C97.511 46.856 97.3465 47.1415 97.1174 47.3705L91.1198 53.3753L58.0186 43.7273L66.9725 37.3323C67.1915 37.175 67.4423 37.0678 67.7073 37.018C67.9723 36.9682 68.2449 36.9772 68.5061 37.0443L96.2822 44.2889Z",
    fill: "#F0D5A8",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2001 22.001C43.0001 24.201 41.9201 29.921 47.2001 35.201C53.8001 41.801 53.8 44.801 51.4 50.801",
    stroke: "#1E0A3C",
    strokeWidth: 0.24
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0661 7.60059C64.2661 9.80059 65.3461 15.5206 60.0661 20.8006C53.4661 27.4006 53.4661 30.4006 55.8661 36.4006",
    stroke: "#1E0A3C",
    strokeWidth: 0.24
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6662 22.001C73.8662 24.201 74.9462 29.921 69.6662 35.201C63.0662 41.801 63.0662 44.801 65.4662 50.801",
    stroke: "#1E0A3C",
    strokeWidth: 0.24
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5166 70.535C65.75 70.7684 66.0418 70.9347 66.3616 71.0165C66.6813 71.0983 67.0171 71.0927 67.3339 71.0001L96.4061 62.5214C96.7129 62.4321 96.9912 62.2643 97.2134 62.0346C97.4357 61.8049 97.5942 61.5213 97.6734 61.2117C97.7527 60.9021 97.7498 60.5772 97.6652 60.269C97.5806 59.9608 97.4171 59.68 97.1909 59.4542L91.1198 53.376L58.0186 63.024L65.5166 70.535Z",
    fill: "#DEBB7E",
    stroke: "#1E0A3C",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/emptyData.744ad1872c4dc8d9a4afd7b9d85e7136.svg";
export { ForwardRef as ReactComponent };